import { BaseMapper } from '@ps/utils';
import { HealthCheckStatusKey } from '@ps/survey-kernel';
import { SurveyHealthMetric } from '@ps/survey-utils';

import { SurveyHealthDto } from '../dtos/survey-health.dto';

const STATUS_TEXT_LOOKUP: Record<string, HealthCheckStatusKey> = {
  RED: 'RED',
  YELLOW: 'YELLOW',
  GREEN: 'GREEN',
  GREY: 'GREY',
};

export class SurveyHealthMapper extends BaseMapper<
  SurveyHealthDto,
  SurveyHealthMetric
> {
  public fromDto(dto: SurveyHealthDto): SurveyHealthMetric {
    return {
      kpi: dto.kpi,
      name: dto.name,
      statusText: STATUS_TEXT_LOOKUP[dto.statusText] ?? 'GREY',
      value: dto.value,
    };
  }
}
